// extracted by mini-css-extract-plugin
export default {"wrap":"q4tIx19bGNFtdevFjM7F","s":"YHrRpD5zzV2G82fNmJcA","m":"KV6TVexIMiZ7n5IMLmpu","strong":"llCrNNlNLkEe6y5v7jmk","subtle":"eZLoEmbv4S3nVHjv9mmV"};